export const menuAside = [
  {
    text: 'Ir para o site',
    link: '/',
    external: true,
    onclick: null,
    public: false
  }
]